import React, { lazy, Suspense } from 'react';
import FullScreenLoader from '../components/Loaders/FullScreenloader';

// Lazy load all page components
const Home = lazy(() => import('../pages/Home/Home'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const PortalPage = lazy(() => import('../pages/V2/Portal'));
const PastPapersPage = lazy(() => import('../pages/PastPapers/PastPapersPage'));
const BlogPage = lazy(() => import('../pages/BlogPage/BlogPage'));
const ManageAccounts = lazy(() => import('../pages/V2/ManageAccounts'));
const StudentOnboarding = lazy(() => import('../pages/V2/StudentOnboarding'));
const WaitingRoomInit = lazy(() => import('../pages/V2/WaitingRoom'));

// Authentication pages
const SignUp = lazy(() => import('../pages/Authentication/SignUp'));
const Login = lazy(() => import('../pages/Authentication/Login'));
const ForgotPassword = lazy(
  () => import('../pages/Authentication/ForgotPassword')
);
const ResetPassword = lazy(
  () => import('../pages/Authentication/ResetPassword')
);

// Question and Quiz pages
const SubTopicListPage = lazy(
  () => import('../pages/QuestionPages/SubTopicListPage')
);
const QuestionsPage = lazy(() => import('../pages/QuestionPages'));
const TrialClassRecordings = lazy(
  () => import('../pages/UserPages/TrialClassRecordings')
);

// Payment pages
const Payment = lazy(() => import('../pages/Payment'));
const ManageSubscriptions = lazy(
  () => import('../pages/Payment/ManageSubscriptions')
);

// Validation pages
const InvalidRoute = lazy(() => import('../pages/Validate/InvalidRoute'));
const VerifyNotesLink = lazy(() => import('../pages/Validate/VerifyNotesLink'));
const StartSubmission = lazy(() => import('../pages/Validate/StartSubmission'));

// Utility components
const ReportIssue = lazy(() => import('../ReportIssue'));

// Curriculum page
const CurriculumPage = lazy(() => import('../pages/UserPages/Curriculum'));

// Loading component wrapper
const RouteLoader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Suspense fallback={<FullScreenLoader />}>{children}</Suspense>
);

// Export lazy components with loading wrapper
export const LazyHome = () => (
  <RouteLoader>
    <Home />
  </RouteLoader>
);

export const LazyDashboard = () => (
  <RouteLoader>
    <Dashboard />
  </RouteLoader>
);

export const LazyPortalPage = () => (
  <RouteLoader>
    <PortalPage />
  </RouteLoader>
);

export const LazyPastPapersPage = () => (
  <RouteLoader>
    <PastPapersPage />
  </RouteLoader>
);

export const LazyBlogPage = () => (
  <RouteLoader>
    <BlogPage />
  </RouteLoader>
);

export const LazyManageAccounts = () => (
  <RouteLoader>
    <ManageAccounts />
  </RouteLoader>
);

export const LazyStudentOnboarding = () => (
  <RouteLoader>
    <StudentOnboarding />
  </RouteLoader>
);

export const LazyWaitingRoomInit = () => (
  <RouteLoader>
    <WaitingRoomInit />
  </RouteLoader>
);

export const LazySignUp = () => (
  <RouteLoader>
    <SignUp />
  </RouteLoader>
);

export const LazyLogin = () => (
  <RouteLoader>
    <Login />
  </RouteLoader>
);

export const LazyForgotPassword = () => (
  <RouteLoader>
    <ForgotPassword />
  </RouteLoader>
);

export const LazyResetPassword = () => (
  <RouteLoader>
    <ResetPassword />
  </RouteLoader>
);

export const LazySubTopicListPage = () => (
  <RouteLoader>
    <SubTopicListPage />
  </RouteLoader>
);

export const LazyQuestionsPage = () => (
  <RouteLoader>
    <QuestionsPage />
  </RouteLoader>
);

export const LazyTrialClassRecordings = () => (
  <RouteLoader>
    <TrialClassRecordings />
  </RouteLoader>
);

export const LazyPayment = () => (
  <RouteLoader>
    <Payment />
  </RouteLoader>
);

export const LazyManageSubscriptions = () => (
  <RouteLoader>
    <ManageSubscriptions />
  </RouteLoader>
);

export const LazyInvalidRoute = () => (
  <RouteLoader>
    <InvalidRoute />
  </RouteLoader>
);

export const LazyVerifyNotesLink = () => (
  <RouteLoader>
    <VerifyNotesLink />
  </RouteLoader>
);

export const LazyStartSubmission = () => (
  <RouteLoader>
    <StartSubmission />
  </RouteLoader>
);

export const LazyReportIssue = () => (
  <RouteLoader>
    <ReportIssue />
  </RouteLoader>
);

export const LazyCurriculumPage = () => (
  <RouteLoader>
    <CurriculumPage />
  </RouteLoader>
);
